import React from 'react';

import AIMessage from '@/features/AIChat/AskGXDrawer/Messages/AIMessage';
import HumanMessage from '@/features/AIChat/AskGXDrawer/Messages/HumanMessage';
import { useChat } from '@/features/AIChat/context/useChat';
import type { Message } from '@/features/AIChat/context/utils';
import isAiMessage from '@/features/AIChat/utils/isAiMessage';
import isHumanMessage from '@/features/AIChat/utils/isHumanMessage';

const MessageComponent = ({ msg, index }: { msg: Message; index: number }) => {
  const { isSending, version, messages } = useChat();

  const isAI = isAiMessage(msg);
  const isLastMessage = index === messages.length - 1;

  const prevMessage = messages.at(index - 1);
  const prompt = isHumanMessage(prevMessage) ? prevMessage.text : '';

  if (isAI) {
    return (
      <AIMessage
        isLastMessage={isLastMessage}
        isSending={isSending}
        msg={msg}
        prompt={prompt}
        version={version}
      />
    );
  }
  return <HumanMessage msg={msg} />;
};
export default MessageComponent;
